export default {
  'categories.shoes': 'Chaussures',
  'categories.hoodies': 'Sweats / Pulls',
  'categories.tshirts': 'T-shirts',
  'categories.jackets': 'Vestes',
  'categories.pants': 'Pantalons / Shorts',
  'categories.headwear': 'Couvre-chefs',
  'categories.sets': 'Ensembles',
  'categories.underwear': 'Sous-vêtements',
  'categories.jersey': 'Maillots',
  'categories.accessories': 'Accessoires',
  'categories.bags': 'Sacs',
  'categories.belts': 'Ceintures',
  'categories.perfumes': 'Parfums',
  'categories.other': 'Autres articles',
};